import {
  HttpRequest,
  HttpInterceptorFn,
  HttpHandlerFn,
  HttpEvent,
  HttpErrorResponse,
  HttpStatusCode,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { getCookie, today } from '@poste-click-connect/shared-ui';
import { Observable, catchError, finalize, tap, throwError } from 'rxjs';
import { ErrorCodes } from '../enum/error-codes.enum';
import { InterceptorService } from '../services/interceptor.service';
import { LoginService } from '../services/login.service';

export const authInterceptor: HttpInterceptorFn = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const token = getCookie('accessToken');
  let clonedRequest = request;
  const service = inject(InterceptorService);
  const loginService = inject(LoginService);
  service.start();


function constantTimeEqual(a: string, b: string): boolean {
  if (a.length !== b.length) return false; 
  let diff = 0;
  for (let i = 0; i < a.length; i++) {
    diff |= a.charCodeAt(i) ^ b.charCodeAt(i);
  }
  return diff === 0; 
}



if (
  token &&
  loginService.loginData?.authToken &&
  !constantTimeEqual(token, loginService.loginData.authToken)
) {
  service.invalidSession();
  service.end();

  throw new HttpErrorResponse({
    error: 'Unauthorized',
    status: HttpStatusCode.Unauthorized,
  });
}


  if (token) {
    clonedRequest = request.clone({
      ...(request.method === 'GET' || request.method === 'POST'
        ? {
            url: `${request.url}${
              request.url.indexOf('?') >= 0 ? '&' : '?'
            }timestamp=${today()}`,
          }
        : {}),
      setHeaders: {
        Authorization: `${token}`,
      },
    });
  }

  return next(clonedRequest).pipe(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    tap((response: any) => {
      if (response?.body?.msgCode === ErrorCodes.AUTHORIZATION_DENIED) {
        service.logout();
      }
    }),
    catchError((err: any) => {
      if (err instanceof HttpErrorResponse) {
        if (err.status === HttpStatusCode.Unauthorized) {
          service.logout();
        }
      }
      return throwError(() => err);
    }),
    finalize(() => {
      service.end();
    })
  );
};
